import { ADD_ADDRESS, DELETE_ADDRESS } from '../types';

export default (state, action) => {
  switch (action.type) {
    case ADD_ADDRESS:
      return {
        ...state,
        userAddress: [...state.userAddress, action.payload],
      };
    case DELETE_ADDRESS:
      return {
        ...state,
        userAddress: state.userAddress.filter(
          (address) => address.id !== action.payload
        ),
      };
    default:
      return state;
  }
};
